import axiosInstanceCore from "./config/axiosCore";
import axiosInstanceTransaction from "./config/axiosTransaction";

export const GET_ALL_PROVIDERS_LKP = (transactionGuid) => {
  return axiosInstanceCore.get(`api/v1/Provider/get-all-providers-lookup`, {
    params: {
      TypeTags: ["E_WALLET", "AGENT_PAYMENT_PROVIDER", "CARD_PAYMENT"],
      PageSize: 100,
      PageIndex: 1,
      TransactionId: transactionGuid,
    },
    paramsSerializer: (params) => {
      return Object.keys(params)
        .map((key) => {
          if (Array.isArray(params[key])) {
            return params[key]
              .map((value) => `${key}=${encodeURIComponent(value)}`)
              .join("&");
          }
          return `${key}=${encodeURIComponent(params[key])}`;
        })
        .join("&");
    },
  });
};

export const GET_PAYMENT_TRANSACTION = (transactionGuid) => {
  return axiosInstanceTransaction.get(`api/v1/Transaction/Merchant/Payment`, {
    params: {
      TransactionGuid: transactionGuid,
    },
  });
};

export const WISH_CHECKOUT = (data) => {
  return axiosInstanceCore.post(`api/v1/transaction/whish-checkout`, data);
};

export const OMT_CHECKOUT = (data) => {
  return axiosInstanceCore.post(`api/v1/transaction/omt-checkout`, data);
};

export const MY_MONTY_SEND_OTP = (data) => {
  return axiosInstanceCore.post(`api/v1/transaction/mymonty-send-otp`, data);
};

export const MY_MONTY_VERIFY_OTP = (data) => {
  return axiosInstanceCore.post(`api/v1/transaction/mymonty-verify-otp`, data);
};

export const CREATE_OMT_VOUCHER = (data) => {
  return axiosInstanceCore.post(`api/v1/omt/voucher/payment`, data);
};


// Card Checkout API
export const CARD_CHECKOUT = async (data) => {  
  return axiosInstanceCore.post(`/api/v1/transaction/card-checkout`, data) 
};
